import { render } from "./FormKegiatanKemitraan.vue?vue&type=template&id=21bf4997&ts=true"
import script from "./FormKegiatanKemitraan.vue?vue&type=script&lang=ts"
export * from "./FormKegiatanKemitraan.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__